<h2 data-testid="SUBSYS5_CONTACT_INFO_TITLE_TXT" class="text-uppercase">
	{{ labels().CONTACT_INFO_COMPONENT_TITLE }}
</h2>

<form class="mt-4" style="width: 40rem;" [formGroup]="form">
	<div class="form-group pb-4">
		<label data-testid="SUBSYS5_CONTACT_INFO_LBL" for="email-address">
			{{ labels().CONTACT_INFO_COMPONENT_EMAIL_ADDRESS }} &nbsp; *
		</label>
		<input data-testid="SUBSYS5_CONTACT_INFO_INPUT" type="text" class="form-control" id="email-address"
			autocomplete="off" [placeholder]="labels().CONTACT_INFO_COMPONENT_EMAIL_ADDRESS" formControlName='email'
			[class.is-invalid]="form.controls.email.invalid && form.controls.email.touched"
			[readOnly]="isReadonly()" />
		<div class="invalid-feedback">
			@if(form.controls.email.hasError('required')) {
			{{ labels().VALIDATION_REQUIRED | replace:labels().CONTACT_INFO_COMPONENT_EMAIL_ADDRESS }}
			}
			@else if(form.controls.email.hasError('pattern')) {
			{{ labels().VALIDATION_EMAIL | replace:labels().CONTACT_INFO_COMPONENT_EMAIL_ADDRESS }}
			}
			@else if(form.controls.email.hasError('maxlength')) {
			{{ labels().VALIDATION_MAXLENGTH | replace:labels().CONTACT_INFO_COMPONENT_EMAIL_ADDRESS:EMAIL_MAXLENGTH }}
			}
		</div>
	</div>
	<div class="form-group py-4">
		<label data-testid="SUBSYS5_CONTACT_INFO_LBL" for="second-email-address">
			{{ labels().CONTACT_INFO_COMPONENT_SECOND_EMAIL_ADDRESS }}
		</label>
		<input data-testid="SUBSYS5_CONTACT_INFO_INPUT" type="text" class="form-control" id="second-email-address"
			autocomplete="off" [placeholder]="labels().CONTACT_INFO_COMPONENT_EMAIL_ADDRESS" formControlName='secondEmail'
			[class.is-invalid]="form.controls.secondEmail.invalid && form.controls.secondEmail.touched"
			[readOnly]="isReadonly()" />
		<div class="invalid-feedback">
			@if(form.controls.secondEmail.hasError('pattern')) {
			{{ labels().VALIDATION_EMAIL | replace:labels().CONTACT_INFO_COMPONENT_EMAIL_ADDRESS }}
			}
			@else if(form.controls.secondEmail.hasError('maxlength')) {
			{{ labels().VALIDATION_MAXLENGTH | replace:labels().CONTACT_INFO_COMPONENT_EMAIL_ADDRESS:EMAIL_MAXLENGTH }}
			}
		</div>
	</div>
</form>
<div data-testid="SUBSYS5_CONTACT_INFO_DESC_TXT" class="fst-italic">
	{{ labels().CONTACT_INFO_COMPONENT_DESCRIPTION }}
</div>